import axios from "axios";
const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
export const API = `${BACKEND_URL}/api`;

// Domaine canonique unique (production) — évite les doublons multi-domaines côté Google.
export const SITE_URL = "https://serrurerie-77.com";

export const PHONE = "07 66 505 505";
export const PHONE_INTL = "+33766505505";
export const COMPANY = "Serrurerie 77";
export const EMAIL = "contact@serrurerie77.fr";

export const ADDRESSES = [
  { street: "1 Avenue Christian Doppler", cp: "77700", city: "Serris" },
  { street: "480 Avenue de l'Europe", cp: "77000", city: "Vaux-le-Pénil" },
  { street: "114 Avenue de l'Épinette", cp: "77100", city: "Meaux" },
];

export const api = axios.create({ baseURL: API });

export const BRANDS = ["FICHET", "VACHETTE", "BRICARD", "PICARD", "POLLUX", "HÉRACLÈS", "MOTTURA", "MUL-T-LOCK"];

const CDN = "https://static.prod-images.emergentagent.com/jobs/acdfb301-9514-43e4-afcf-5c9330a59a74/images";
export const IMAGES = {
  hero: `${CDN}/479fff0c0c09edb898ffe85698fb723399fa6d96ea8d1403013bcd143f64a5c0.jpeg`,
  tech: `${CDN}/479fff0c0c09edb898ffe85698fb723399fa6d96ea8d1403013bcd143f64a5c0.jpeg`,
  van: `${CDN}/beb2b9888767b0a1640c407dcb6517702a905fdd1b3ce699914d8bc294f0813f.jpeg`,
  cylinder: `${CDN}/19ca903fe0fb55b3578f1da1ffff20fe143868b7d41f3fdbb2741bdb7a25991b.jpeg`,
  handleDark: `${CDN}/d803b44f93ab291516d485eae4493086ca6c4bb5e0df5ff05b18354fafb8375f.jpeg`,
  techHandle: `${CDN}/6c8822b31f188ff3bbc3c639fe9557a4e4fa43582165dd4d9f52558aa1c35ca3.jpeg`,
  coverEte: `${CDN}/550ac67c12f4c68a971c68806e539a12d6fdf212cf47f3c2f099f990c89c6480.jpeg`,
  coverRentree: `${CDN}/490ec8ec408238920c0dde91207cc87a488b5fb548104e70efdddb2d68177e36.jpeg`,
  coverHiver: `${CDN}/07be3d7399f0c789c0da180cd5d924e80b5ff7bc6975060e95bddc302eab92bb.jpeg`,
  coverFetes: `${CDN}/99671ea86c3c82d8fba8021a391c7ad7613c3d2e1dcb830aff3af1c944980d7f.jpeg`,
  // aliases
  get drill() { return this.van; },
  get lever() { return this.techHandle; },
  get install() { return this.tech; },
  get steelDoor() { return this.handleDark; },
  get handover() { return this.van; },
  get handle() { return this.handleDark; },
  get premiumLock() { return this.cylinder; },
};

export const coverSrc = (a) => (a && a.cover_url) ? `${BACKEND_URL}${a.cover_url}` : (IMAGES[a && a.cover] || IMAGES.tech);
